import React from 'react';
import { useIntl } from 'react-intl';
import { Alert } from 'reactstrap';
import { TypedMemo } from '../../../../common/types';
import { lyricTimingMessages } from './lyricTimingMessages';
import { LyricResyncNote } from './resyncOutcome';
import { withBrandWord } from '../../../../music24/components/primitives/BrandWord';

interface LyricResyncNoteViewProps {
  note: LyricResyncNote | null;
}

/**
 * The result of Re-sync, next to the button (the inline pattern of the Studio actions): the
 * refusal sentence, or "Synced again" when the sync of this page ended.
 */
const LyricResyncNoteViewComponent: React.FC<LyricResyncNoteViewProps> = ({ note }) => {
  const intl = useIntl();
  if (note === null) {
    return null;
  }
  if (note.kind === 'error') {
    return (
      <Alert color="danger" className="mb-0 small text-break" role="alert" data-testid="lyric-resync-note">
        {withBrandWord(note.message)}
      </Alert>
    );
  }
  return (
    <Alert color="success" className="mb-0 small" role="status" data-testid="lyric-resync-note">
      {intl.formatMessage(note.timesChanged ? lyricTimingMessages.resyncDone : lyricTimingMessages.resyncDoneSame)}
    </Alert>
  );
};

export const LyricResyncNoteView = TypedMemo(LyricResyncNoteViewComponent);
